import {Auth0Gate, AuthErrorScreen} from '@sollapay/web-core';
import {Outlet} from 'react-router-dom';

import {DesktopOnlyScreen} from '@/app/DesktopOnlyScreen';
import {useIsMobileDevice} from '@/hooks';

import {LoginFormSkeleton} from './LoginFormSkeleton';
import {LoginPosterBackground} from './LoginPosterBackground';

import type {FC, ReactNode} from 'react';

export interface RequireAuthProps {
  returningLoadingContent: ReactNode;
}

export const RequireAuth: FC<RequireAuthProps> = ({returningLoadingContent}) => {
  const isMobileDevice = useIsMobileDevice();

  return (
    <Auth0Gate
      loadingContent={<LoginFormSkeleton />}
      returningLoadingContent={returningLoadingContent}
      errorContent={(errorCode, onRetry) => (
        <AuthErrorScreen
          errorCode={errorCode}
          onRetry={onRetry}
          background={<LoginPosterBackground />}
        />
      )}
    >
      {isMobileDevice ? <DesktopOnlyScreen /> : <Outlet />}
    </Auth0Gate>
  );
};
